export class GetAdditionalExpensesByIdRequest {
    public additionalExpenseIds: string[] = [];

    public includeDeleted: boolean = false;
}